import { request } from '@/service/http'

/**
 *  获取带分页的资料列表
 */
export function userinfoGetList(data: Search.Common) {
  const methodInstance = request.Post<Service.ResponseResult<DomainService.Userinfo.Info>>('/domain-service/userinfo/getList', data)
  return methodInstance
}

/**
 *  获取不带分页的资料列表
 */
export function getAllUserinfo() {
  const methodInstance = request.Get<Service.ResponseResult<DomainService.Userinfo.RecordItem[]>>('/domain-service/userinfo/getAllUserinfo')
  return methodInstance
}

/**
 *  删除指定模板
 */
export function userinfoDelete(data: number) {
  const methodInstance = request.Post<Service.ResponseResult<Service.RequestError>>(`/domain-service/userinfo/delete?id=${data}`)
  return methodInstance
}

/**
 *  查询模板详情
 */
export function userinfoGetInfo(id: string | number) {
  const methodInstance = request.Get<Service.ResponseResult<DomainService.Userinfo.TemplateInfo>>(`/domain-service/userinfo/getInfo?id=${id}`)
  return methodInstance
}

/**
 *  新增模板
 */
export function userinfoAdd(data: DomainService.Userinfo.TemplateInfo) {
  const methodInstance = request.Post<Service.ResponseResult<Service.RequestError>>('/domain-service/userinfo/add', data)
  return methodInstance
}

/**
 *  修改模板
 */
export function userinfoUpdate(data: DomainService.Userinfo.TemplateInfo) {
  const methodInstance = request.Post<Service.ResponseResult<Service.RequestError>>('/domain-service/userinfo/update', data)
  return methodInstance
}

/**
 *  设置模板默认状态
 */
export function setDefault(data: number) {
  const id = data.id
  const methodInstance = request.Post<Service.ResponseResult<Service.RequestError>>(`/domain-service/userinfo/setDefault?id=${id}`)
  return methodInstance
}

/**
 *  提交域名实名模板实名资料
 */
export function dataRealName(data: DomainService.Domain.RealNameData) {
  const methodInstance = request.Post<Service.ResponseResult<Service.RequestError>>('/domain-service/domain/dataRealName', data)
  return methodInstance
}

/**
 *  通过订单号和模板号更新用户资料
 */
export function updateContactsByUserinfo(data: { orderId: string, userInfoId: number }) {
  const methodInstance = request.Post<Service.ResponseResult<Service.RequestError>>('/domain-service/domainOrderAssociation/UpdateContactsByUserinfo', data)
  return methodInstance
}

/**
 *  查询域名详情
 */
export function getDataRealnameInfos(id: any) {
  const methodInstance = request.Get<Service.ResponseResult<any>>(`/domain-service/userinfo/getDataRealnameInfos?id=${id}`)
  return methodInstance
}
